<template>
  <svg
    class="sf-divider"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 10 10"
  >
    <line
      class="sf-divider__line sf-divider__line--horizontal"
      x1="0%"
      x2="100%"
      y1="50%"
      y2="50%"
      stroke-linecap="round"
      vector-effect="non-scaling-stroke"
    />
    <line
      class="sf-divider__line sf-divider__line--vertical"
      x1="50%"
      x2="50%"
      y1="0%"
      y2="100%"
      stroke-linecap="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>

<script setup lang="ts">
/**
 * This is a divider element that can be configured to be displayed horizontally or vertically.
 *
 * It's made to be configured through CSS, rather than through props, because then we can change
 * its styles dynamically through media queries, for example.
 *
 * To toggle its direction between horizontal and vertical, use the
 * `divider-orientation($direction: horizontal | vertical)` mixin.
 */
</script>

<style lang="scss">
.sf-divider {
  width: 100%;
  height: 2px;
  stroke: $c-border-7;
  stroke-width: 2;
  stroke-dasharray: 8 8;
  @include divider-orientation(horizontal);

  &__line--horizontal {
    display: var(--divider-show-horizontal, 'block');
  }

  &__line--vertical {
    display: var(--divider-show-vertical, 'none');
  }
}
</style>
